import ReassginOwnerPopup from "./reassignOwnerPopUp";
import React, { useEffect, useState, Fragment, useRef } from "react";
import { connect } from "react-redux";
import {
  addFeedbackResolution,
  getFeedbackResolutionsStatuses,
  getLastUpdatedResolutions,
} from "../../../api/feedback.service";
import moment from "moment";
import Loader from "../../shared/loader/loader";
import { useNavigate } from "react-router";
import Constant from "../../../utils/constant";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { AddIcon, CopyIcon } from "../../../assets/icons";
import { toast } from "react-toastify";
import CopyToClipboard from "../../shared/common/CustomCopyToClipboard";
import TeacherFeedbackUpdatePopup from "../questions/teacherFeedbackUpdatePopup";
import { ISelectElement } from "../../../model/interface/keyValuePair";

export type IFeedbackResolutionsList = {
  feedbackId: number;
  feedbackResolutionId?: number;
  submittedByLastName?: string;
  submittedByFirstName?: string;
  submittedByEmail?: string;
  schoolName?: string;
  schoolCity?: string;
  questionId: number;
  contentAreaName?: string;
  feedbackComments?: string;
  referenceType?: string;
  feedbackSubmittedDate?: Date;
  feedbackStatusTypeId?: number;
  feedbackStatus?: string;
  resolutionComments?: string;
  resolvedByLastName?: string;
  resolvedByFirstName?: string;
  lastUpdated?: Date;
  reporterType?: number;
  standardId?: number;
  standardName: string;
  standardCode: string;
};

const Feedback = () => {
  const defaultPageNumber = 1;
  const defaultPageSize = 20;
  const navigate = useNavigate();
  const [ownerPopup, setOwnerPopup] = useState<boolean>(false);
  const [statusUpdatePopup, setStatusUpdatePopup] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [feedbackStatuses, setFeedbackStatuses] = useState<ISelectElement[]>(
    []
  );
  const [feedbackResolutions, setFeedbackResolutions] = useState<
    IFeedbackResolutionsList[]
  >([]);
  const [feedbackResolutionId, setFeedbackResolutionId] = useState<
    number | undefined
  >(0);
  const [feedbackId, setFeedbackId] = useState<number | undefined>(0);
  const [statusId, setStatusId] = useState<number | undefined>(0);
  const [comment, setComment] = useState<string | undefined>("");
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showClosed, setShowClosed] = useState<boolean>(false);

  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const closeReassignOwnerModal = () => {
    setOwnerPopup(false);
  };
  const reassignOwner = () => {
    setOwnerPopup(false);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {
    getFeedbacks();
    getFeedbackStatuses();
  }, []);

  useEffect(() => {
    getFeedbacks();
  }, [showClosed]);

  useEffect(() => {
    //console.log("pageNumber changed");
    if (pageNumber > totalPages && pageNumber > 1) {
      paginationRef.current.onReset();
      return;
    }
    getFeedbacks();
  }, [pageNumber]);

  useEffect(() => {
    //console.log("pageSize changed");
    setTotalPages(Math.ceil(totalRecords / pageSize));
    getFeedbacks();
  }, [pageSize]);

  const showStatusUpdateModal = (feedback: IFeedbackResolutionsList) => {
    setFeedbackId(feedback.feedbackId);
    setFeedbackResolutionId(feedback.feedbackResolutionId);
    setStatusId(feedback.feedbackStatusTypeId);
    setComment(feedback.resolutionComments);
    setStatusUpdatePopup(true);
  };

  const getFeedbackStatuses = async () => {
    const res = await getFeedbackResolutionsStatuses();
    let statuses: ISelectElement[] = [];
    if (res.data.length > 0) {
      statuses = res?.data.map((element) => {
        return {
          value: element.id || 0,
          label: `${element.name}`,
        };
      });
    }
    setFeedbackStatuses(statuses);
  };

  const getFeedbacks = async () => {
    //console.log("Getting feedbacks");
    setFeedbackResolutions([]);
    setLoading(true);
    const res = await getLastUpdatedResolutions(
      undefined,
      showClosed,
      pageNumber,
      pageSize
    );
    if (res?.data?.data) {
      const pages = Math.ceil(res.data.totalRecords / pageSize);
      setFeedbackResolutions(res.data.data);
      setTotalRecords(res.data.totalRecords);
      setTotalPages(pages);

      if (pageNumber > pages && pageNumber > 1) {
        paginationRef.current.onReset();
      }
    } else if (pageNumber > 1) paginationRef.current.onReset();
    setLoading(false);
  };

  const saveFeedback = async (statusId: number, comment: string) => {
    const res = await addFeedbackResolution({
      feedbackId: feedbackId,
      feedbackStatusTypeId: statusId,
      resolutionComments: comment,
    });
    await getFeedbacks();
    setStatusUpdatePopup(false);
  };

  const handleReferenceClick = (
    reference: number,
    referenceType: string | undefined
  ) => {
    let link = "";
    switch (referenceType?.toUpperCase()) {
      case "QUESTION":
        link = Constant.MANAGEQUESTION.replace(":id", reference.toString());
        break;
      case "WORKSHEET":
        link = Constant.WORKSHEETEDIT.replace(":id", reference.toString());
        break;
      case "VIDEO":
        link = Constant.VIDEOEDIT.replace(":id", reference.toString());
        break;
    }
    if (link != "") {
      navigate(link);
    }
  };

  const handleStandardClick = (standardId: number) => {
    navigate(Constant.EDITSTANDARD.replace(":id", standardId.toString()));
  };

  return (
    <>
      {loading && <Loader />}
      {ownerPopup && (
        <ReassginOwnerPopup
          closeReassignOwnerModal={closeReassignOwnerModal}
          reassignOwner={reassignOwner}
        />
      )}
      {statusUpdatePopup && (
        <TeacherFeedbackUpdatePopup
          action={"Add"}
          closeStatusUpdateModal={() => setStatusUpdatePopup(false)}
          statusUpdate={saveFeedback}
          feedbackResolutionId={feedbackResolutionId}
          statusId={statusId}
          comment={comment}
          feedbackStatuses={feedbackStatuses}
        />
      )}
      <label className="flex items-center mb-4">
        <input
          id="showClosed"
          name="showClosed"
          type="checkbox"
          checked={showClosed}
          onChange={() => setShowClosed(!showClosed)}
          className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
        />
        <span className="ml-2 dark:text-white">Show Closed</span>
      </label>
      <div className="w-full shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
        <div id="dataContainer" className="mt-0 overflow-auto">
          <div className="flex flex-col mt-1">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-primary-color">
                <tr className="border-t border-gray-200">
                  <th
                    scope="col"
                    className="px-5 py-2 pl-1 font-light text-sm text-left text-white dark:text-white tracking-wider rounded-tl-lg"
                  >
                    <span className="flex">User</span>
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">School</span>
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">Category</span>
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">Id</span>
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">Content Area</span>
                  </th>
                  <th
                    scope="col"
                    className="w-[20%] px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">Standard</span>
                  </th>
                  <th
                    scope="col"
                    className="w-[20%] px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                  >
                    <span className="flex">Text</span>
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                  >
                    Comments
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                  >
                    Who Fixed?
                  </th>
                  <th className="hidden md:table-cell px-3 py-2 text-left text-xs font-light text-white dark:text-white uppercase tracking-wider">
                    Last updated
                  </th>
                  <th className="hidden md:table-cell  py-3 text-left text-xs font-light text-white dark:text-white uppercase tracking-wider" />
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {feedbackResolutions.map((feed, index) => (
                  <tr key={index}>
                    <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                      <div className="flex">
                        {feed.submittedByLastName +
                          (feed.submittedByFirstName
                            ? ", " + feed?.submittedByFirstName
                            : "")}
                        <CopyToClipboard text={feed.submittedByEmail || ""}>
                          <CopyIcon
                            title="Copy submitted-by email"
                            onClick={() => {
                              toast.success("Submitted-by copied to clipboard");
                            }}
                          />
                        </CopyToClipboard>
                      </div>
                    </td>

                    <td className="px-3 py-2  whitespace-wrap text-sm text-left font-normal text-gray-500">
                      <p
                        className={`inline-block bg-green rounded-full text-xs shadow-sm py-0.5 px-3 `}
                      >
                        {feed.schoolName +
                          (feed.schoolCity ? ", " + feed.schoolCity : "")}
                      </p>
                    </td>
                    <td className="px-3 py-2  whitespace-wrap text-sm text-left font-normal text-gray-500">
                      <p>{feed.referenceType}</p>
                    </td>
                    <td className="px-3 py-2 flex ">
                      <span
                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                        onClick={() =>
                          handleReferenceClick(
                            feed.questionId,
                            feed.referenceType
                          )
                        }
                      >
                        {feed.questionId}
                      </span>
                    </td>
                    <td className="px-3 py-2  whitespace-wrap text-sm text-left font-normal text-gray-500">
                      {feed.contentAreaName}
                    </td>
                    <td className="px-3 py-2  whitespace-wrap text-sm text-left font-normal text-gray-500">
                      {(feed.standardId ?? 0) > 0 && (
                        <>
                          <span
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            onClick={() =>
                              handleStandardClick(feed.standardId!)
                            }
                          >
                            {feed.standardName} ({feed.standardCode})
                          </span>
                        </>
                      )}
                    </td>
                    <td className="px-3 py-2 flex cursor-pointer font-medium">
                      {feed.feedbackComments}
                    </td>

                    <td className="px-3 py-2 whitespace-wrap text-sm textleft font-normal text-gray-500">
                      {moment(feed.feedbackSubmittedDate).format(
                        "MMMM DD,YYYY"
                      )}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm textleft font-normal text-gray-500">
                      {feed.feedbackStatus}
                    </td>
                    <td className="px-3 py-2 whitespace-wrap text-sm textleft font-normal text-gray-500">
                      {feed.resolutionComments}
                    </td>
                    <td className="px-3 py-2 whitespace-wrap text-sm textleft font-normal text-gray-500">
                      {(feed.resolvedByLastName
                        ? feed.resolvedByLastName
                        : "") +
                        (feed.resolvedByFirstName
                          ? ", " + feed?.resolvedByFirstName
                          : "")}
                    </td>
                    <td className="hidden md:table-cell px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-left">
                      {moment(feed.lastUpdated).format("MMMM DD,YYYY")}
                    </td>
                    <td className="border-gray-200 w-8">
                      <div className="flex gap-3 justify-center">
                        <AddIcon
                          title="Add resolution"
                          onClick={() => showStatusUpdateModal(feed)}
                          className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center">
        {totalRecords !== 0 ? (
          <>
            <Pagination
              pages={totalPages}
              setPageNumber={setPageNumber}
              ref={paginationRef}
            />
            <span>
              <span className="text-sm pr-4 ml-auto text-left-700">
                Showing {pageNumber} to{" "}
                {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                {totalRecords} results
              </span>

              <SelectPageSize
                setPageSize={setPageSize}
                type={"second"}
                ref={pageSizeRef}
                defaultPage={pageSize}
              />
            </span>
          </>
        ) : (
          <p className="p-2">No Records Found</p>
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(Feedback);
